import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import styles from './AspectRatio.module.scss';

export type AspectRatioProps = PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>;

export const AspectRatio = ({ children, className, ...props }: AspectRatioProps) => (
  <div className={classNames(styles.root, className)} {...props}>
    <div className={styles.inner}>{children}</div>
  </div>
);
